import expenseReducer from './expenseReducer';
import authReducer from './authReducer';
import {combineReducers} from 'redux';
import {firestoreReducer} from 'redux-firestore'
import {firebaseReducer} from 'react-redux-firebase'
import authenticationReducer from './authenticationReducer';

//Combing all the reducers created for authentication, adding expenses, firebase,firestore into one rootreducer
const rootReducer = combineReducers({
    expense : expenseReducer,
    auth: authReducer,
    authentication : authenticationReducer,
    firestore: firestoreReducer,
    firebase: firebaseReducer
});
export default rootReducer;